import React from "react";
import styled from "styled-components";
import { Row, Col, Form, Button, Stack } from "react-bootstrap";
import Table from "./Table";
import { useState, useMemo } from "react";
import Pagination from "../../organisms/Pagination";
import { VentaDelMes } from "../../../services/ventasServicios";
import { dateCompare } from "../../../utils/dateUtils";
import { filterByStringIgnoreCase } from "../../../utils/tableUtils";

function TableSection({
  ventas,
  onSeleccionarVenta,
}: {
  ventas: VentaDelMes[];
  onSeleccionarVenta: (idVenta: string) => void;
}) {
  const [filtro, setFiltro] = useState("");
  const [finalFilter, setFinalFilter] = useState("");
  const [activePageNumber, setActivePageNumber] = useState(1);
  const [itemsToShow, setItemsToShow] = useState(20);

  const items = useMemo(() => {
    let ventasOrdenadas = ventas;
    ventasOrdenadas.sort((itemA, itemB) => {
      return dateCompare(itemA.fecha, itemB.fecha);
    });
    return ventasOrdenadas;
  }, [ventas]);

  const onBuscar = (newFilter: string) => setFinalFilter(newFilter);

  const itemsFiltrados = useMemo(
    () => filterByStringIgnoreCase<VentaDelMes>(items, finalFilter),
    [items, finalFilter]
  );

  const page = useMemo(
    () => generatePage(itemsFiltrados, activePageNumber, itemsToShow),
    [itemsFiltrados, activePageNumber, itemsToShow]
  );
  return (
    <ResponsiveTableSection>
      <TableWrapper>
        <Stack gap={4}>
          <TableLengthSection>
            <Form>
              <StyledFormGroup as={Row}>
                <Form.Label column sm="auto">
                  Items:
                </Form.Label>
                <Col sm="auto">
                  <StyledFormSelect
                    value={itemsToShow}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                      setItemsToShow(parseInt(e.target.value))
                    }
                  >
                    {[5, 10, 20].map((pageSize, index) => (
                      <option key={index} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </StyledFormSelect>
                </Col>
                <Form.Label column sm="auto">
                  Filtro:
                </Form.Label>
                <Col sm="auto">
                  <StyledFormControl
                    type="text"
                    value={filtro}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setFiltro(e.target.value)
                    }
                  />
                </Col>
                <Col sm="auto">
                  <Button variant="primary" onClick={() => onBuscar(filtro)}>
                    Buscar
                  </Button>
                </Col>
              </StyledFormGroup>
            </Form>
          </TableLengthSection>
          <Table items={page} onSeleccionarVenta={onSeleccionarVenta} />
          <div>
            <Pagination
              pageSize={itemsToShow}
              setActivePageNumber={setActivePageNumber}
              activePageNumber={activePageNumber}
              rows={itemsFiltrados}
            />
          </div>
        </Stack>
      </TableWrapper>
    </ResponsiveTableSection>
  );
}

function generatePage<T>(
  rows: Array<T>,
  pageNumber: number,
  pageSize: number
): Array<T> {
  const end = pageNumber * pageSize;
  const start = end - pageSize;
  return rows.slice(start, end);
}

const ResponsiveTableSection = styled("div")`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableWrapper = styled("div")`
  position: relative;
  clear: both;
  zoom: 1;
`;

const TableLengthSection = styled("div")`
  float: left;
`;

const StyledFormGroup = styled(Form.Group)`
  justify-content: start;
`;
const StyledFormControl = styled(Form.Control)`
  &:focus {
    box-shadow: none;
  }
`;

const StyledFormSelect = styled(Form.Select)`
  &:focus {
    box-shadow: none;
  }
`;

export default TableSection;
